import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appSplitterPanel]',
  standalone: false,
})
export class SplitterPanelDirective {
  constructor(public template: TemplateRef<any>) {}
}
